<template>
  <section class="discord-tutorial">
	<span
		class="discord-tutorial__cross"
		data-testid="close"
		@click.prevent="closeModal"
	>
		<img :src="require(`images/commons/close.svg`)" />
	</span>
	<img
		class="discord-tutorial__header-img"
		:src="require('images/discord/discord-header.png')"
		alt="Connect Discord"
	/>
	<section class="discord-tutorial__steps">
		<article
			v-for="stepNumber in steps"
			:key="stepNumber"
			class="discord-tutorial__step"
		>
			<div class="discord-tutorial__step-text">
				<h2 class="discord-tutorial__title">
					{{$t(`modalDiscord.step${stepNumber}`)}}
				</h2>
				<p class="discord-tutorial__text">
					{{$t(`modalDiscord.step${stepNumber+1}-text`)}}
				</p>
			</div>
			<img
				:src="require(`images/discord/discord-step${stepNumber}.png`)"
				:data-testid="`image-step${stepNumber}`"
				class="discord-tutorial__step-image"
			/>
		</article>
	</section>
	<section class="discord-tutorial__bottom-section">
		<div
			class="discord-tutorial__more-info"
			@click="openMoreInfo"
		>
			{{$t('modalDiscord.more-info')}}
		</div>
		<button
			class="discord-tutorial__button"
			@click="openDiscordSettings"
		>
			{{$t('modalDiscord.CTA')}}
		</button>
	</section>
	<section class="discord-tutorial__checkbox">
		<label>
			<input type="checkbox" v-model="checkboxValue" @click="dontShowCheckBoxClicked">
			{{$t('modalDiscord.checkbox')}}
		</label>
	</section>
  </section>
</template>

<script>
export default {
    data() {
        return {
            checkboxValue: false,
            steps: 2,
            moreInfoLink:
				'https://support.voicemod.net/hc/en-us/articles/360013438419-How-to-set-up-Voicemod-on-Discord',
        };
    },
    mounted() {
        window.ApplicationViewModel.sendDiscordSetupPopupOpenMetrics();
    },

    methods: {
        closeModal() {
            window.ApplicationViewModel.sendDiscordSetupPopupClosedMetrics();
            window.ApplicationViewModel.closeConfigurationGuideDialog('DISCORD_GUIDE', this.checkboxValue);
        },
        openDiscordSettings() {
            window.ExternalBrowserViewModel.openDiscordDeepLink('//-/settings/voice');
        },
        openMoreInfo() {
            window.ApplicationViewModel.sendMoreInfoClickedMetrics();
            window.ExternalBrowserViewModel.openExternalUrl(this.moreInfoLink);
        },
        dontShowCheckBoxClicked() {
            window.ApplicationViewModel.sendDontShowAgainCheckboxClickedMetrics(!this.checkboxValue);
        },
    },
};
</script>

<style src="./DiscordTutorialView.scss" lang="scss">
</style>